
    <button (click)="fileInput.click()" [matTooltip]="tooltip" mat-icon-button color="primary">
      <i class="fas fa-upload"></i>
    </button>
    <span
      style="visibility: hidden; position: absolute; overflow: hidden; width: 0px; height:0px;border:none;margin:0; padding:0">
			<input type="file"
             #fileInput
             [id]="id"
             (change)="handleFileInput($event.target.files)">
</span>
  